
// Bei jQuery Skripten, unbedingt importieren:
import $ from 'jquery';
import "flexslider";

//  Aufruf der Modul-Funktion
$(document).ready(function() {
    if( $('.mainslider').length ) {
        $('.mainslider').flexslider({
            animation: "slide",
            directionNav: true,
            touch: true,
            slideshow: true,
            slideshowSpeed: 4000
        });
    }
});